import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValidationMessageService} from '../../../shared/services/validation-message-handle';
import {QuestionService} from '../../services/question.service';
import {UserService} from '../../../auth/services/user.service';
import {ToastrService} from 'ngx-toastr';
import {QuestionModel} from '../../models/question.model';
import {UserModel} from '../../../auth/models/user.model';
import {finalize} from 'rxjs/operators';
import {ApiResponseModel} from '../../../shared/entities/api-response.model';
import {AnswerModel, AnswersTypeModel} from '../../models/answer.model';
import {HttpErrorResponse} from '@angular/common/http';
import {QuestionnaireModel} from '../../models/questionnaire.model';


@Component({
  selector: 'admin-questionnaire-show',
  templateUrl: './questionnaire-show.component.html',
  styleUrls: ['./questionnaire-show.component.scss']
})

export class QuestionnaireShowComponent implements OnInit {

  public loading = false;
  public questionnaireForm: FormGroup;
  public questionnaire: QuestionnaireModel = new QuestionnaireModel();
  private resultForUser: UserModel;

  private resultDate: Date;

  @Input() resultUid: string;
  @Input() uid: string;

  constructor(
      private route: ActivatedRoute,
      private _formBuilder: FormBuilder,
      private validationMessageService: ValidationMessageService,
      private questionnarieService: QuestionService,
      private toastr: ToastrService,
      private router: Router
  ) {

    this.uid = this.route.snapshot.queryParams['uid'];
    this.resultUid = this.route.snapshot.queryParams['resultUid'];
  }

  ngOnInit(): void
  {

    if(this.uid === null && this.resultUid === null){
      this.router.navigate(['questionnaires/list']);
    }

    if (this.uid) {
      this.getQuestionnarie(this.uid);
    }

    if (this.resultUid) {
      this.getQuestionnarieReadOnlyUse(this.resultUid);
    }


  }

  getQuestionnarie(uid: string): void
  {
    this.loading = true;
    this.questionnarieService.getQuestionnaire(uid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response: ApiResponseModel) => {

          if(response.payload.isDoneByMe && this.uid){
            this.toastr.error('Acest chestionar a fost deja rezolvat.','Eroare 404!');
            this.router.navigate(['/questionnaires/list']);
          }

          const questions: Array<any> = response.payload.questions;
          const questionsList = [];

          const _this = this;

          this.uid = response.payload.uid;

          this.questionnaire.map(response.payload);


          questions.forEach(function(value, index){
            debugger;
            const answareType = JSON.parse(value.answareType);

            console.log('A Type -> ', answareType);

            const questionValues = JSON.parse(value.values);
            const questionModel = new QuestionModel().map({
              id: value.id,
              uid: value.uid,
              position: value.position,
              questionName: value.questionName,
              answerType: new AnswersTypeModel().map(answareType),
              answer: new AnswerModel(),
            });

            questionModel.answer.text = value.questionName;
            questionModel.answer.type = answareType;
            questionModel.answer.values = questionValues;

            questionsList.push(questionModel);
          });

          console.log('questionsList -> ', questionsList);
          this.questionnaire.questions = questionsList;


          console.log(this.questionnaire);

        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.questionnaireForm, '');
          }
        });

  }


  getQuestionnarieReadOnlyUse(uid: string): void
  {
    this.loading = true;
    this.questionnarieService.getUserQuestionnaireResult(uid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response: ApiResponseModel) => {

          this.questionnaire = response.payload.data;
          this.resultForUser = response.payload.user;
          this.resultDate = response.payload.created_at;

        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.questionnaireForm, '');
          }
        });

  }

  compareObjects(o1: any, o2: any): boolean {
    if (o1 && o2){
      return o1.uid === o2.uid;
    }else{
      return false;
    }
  }

  validateAnswares(): boolean
  {
    // TODO Validate he pass all questions!

    const _this = this;
    let hasError = false;

    this.questionnaire.questions.forEach(function(value){

      if ( !value.answer.value ) {
        _this.toastr.error('Nu ati raspuns la pozitia:  [' + value.position + '] ' + value.questionName, 'Trebuie sa completati toate punctele!');
        hasError = true;
      }

    });

    console.log('Has Error -> ', hasError);

    // @ts-ignore
    return (hasError === true) ? false : true;
  }

  onSaveQuestionnaire(): void {

    if (!this.validateAnswares()) {
      return;
    }

    this.loading = true;
    this.questionnarieService.saveUserQuestionnaireResult(this.questionnaire)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response: ApiResponseModel) => {
          this.toastr.success('Chestionarul a fost salvat cu succes!', 'Succes!');
          this.router.navigate(['/questionnaires/list']);
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.questionnaireForm);
          }
        });
    


  }

  onUpdateQuestion($event: QuestionModel): void {
    const foundIndex = this.questionnaire.questions.findIndex(x => x.uid.toString() === $event.uid.toString());
    console.log(foundIndex, this.questionnaire.questions[foundIndex]);
  }

}
